import { motion } from "framer-motion";
import { PackagePlus, GitCompareArrows, Truck, Radar } from "lucide-react";

const STEPS = [
  { n: "01", icon: PackagePlus, title: "CREATE SHIPMENT", desc: "Add delivery details or sync orders from your store.", tint: "#FF9933" },
  { n: "02", icon: GitCompareArrows, title: "COMPARE COURIERS", desc: "See live rates, ETA, ratings and COD availability.", tint: "#12C8F5" },
  { n: "03", icon: Truck, title: "BOOK PICKUP", desc: "AWB and shipping label generated instantly.", tint: "#10B981" },
  { n: "04", icon: Radar, title: "TRACK DELIVERY", desc: "Unified branded tracking until proof of delivery.", tint: "#FF9933" },
];

export default function HowItWorks() {
  return (
    <section className="relative bg-[#F7FAFC] py-20 text-shipany-navy sm:py-24" data-testid="how-it-works">
      <div className="mx-auto max-w-7xl px-5">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#0757D9]">How It Works</span>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">Live in Four Steps</h2>
        </motion.div>
        <div className="relative mt-14">
          <motion.div initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1.4, ease: "easeInOut" }}
            className="absolute left-0 right-0 top-8 hidden h-0.5 origin-left bg-gradient-to-r from-[#FF9933] via-[#12C8F5] to-[#10B981] lg:block" />
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {STEPS.map((s, i) => (
              <motion.div key={s.n} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.18, duration: 0.55 }} className="relative text-center lg:text-left" data-testid={`step-${s.n}`}>
                <div className="relative z-10 mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border bg-white shadow-lg lg:mx-0"
                  style={{ borderColor: `${s.tint}55`, boxShadow: `0 10px 30px ${s.tint}22` }}>
                  <s.icon className="h-7 w-7" style={{ color: s.tint }} />
                </div>
                <p className="mono mt-4 text-3xl font-extrabold" style={{ color: `${s.tint}` }}>{s.n}</p>
                <h3 className="font-display mt-1 text-base font-extrabold tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
